import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import { createColumnHelper } from "@tanstack/react-table";

import PagedTable from "../shared/Tables/PagedTable";
import formatDateTime from "../../utils/formatDateTime";
import { ILead, LeadStatus } from "../../models/Lead";
import ContactFromId from "../contacts/ContactFromId";

const colHelper = createColumnHelper<ILead>();

const formatCellDate = (dateValue: string | null | undefined, fallback = "-") => {
  if (!dateValue) return fallback;
  return formatDateTime(dateValue, DateTime.DATETIME_SHORT);
};

export default function DeletedLeadsTable() {
  const { t } = useTranslation("leads");
  const columns = [
    colHelper.accessor("deleted", {
      header: t("Deleted On"),
      id: "deleted",
      sortingFn: "auto",
      cell: (info) => formatCellDate(info.getValue(), t("Unknown")),
    }),
    colHelper.accessor("deletedBy", {
      header: t("Deleted By"),
      id: "deletedByName",
      sortingFn: "auto",
      cell: (info) => <ContactFromId contactId={info.getValue() ?? ""} />,
    }),
    colHelper.accessor("contact.fullname", {
      header: t("Customer"),
      id: "contactName",
      sortingFn: "auto",
      cell: (info) => (
        <div>
          <p>{info.getValue() || t("Unknown")}</p>
          <p className="text-gray-500">{info.row.original.contact?.telephone1 || "-"}</p>
        </div>
      ),
    }),
    colHelper.accessor("vehicle.vrm", {
      header: t("Vehicle"),
      id: "vehicleVrm",
      sortingFn: "auto",
      cell: (info) => (
        <div>
          <p>{info.getValue() || "-"}</p>
          <p className="text-gray-500">
            {`${info.row.original.vehicle?.combinedMake || ""} ${info.row.original.vehicle?.combinedModel || ""}`.trim() || "-"}
          </p>
        </div>
      ),
    }),
    colHelper.accessor("status", {
      header: t("Status"),
      id: "status",
      sortingFn: "auto",
      cell: (info) => t(LeadStatus[info.getValue()]),
    }),
    colHelper.accessor("ccid", {
      header: t("CCID"),
      id: "ccid",
      sortingFn: "auto",
      cell: (info) => info.getValue() || "-",
    }),
    colHelper.accessor("created", {
      header: t("Created"),
      id: "created",
      sortingFn: "auto",
      cell: (info) => formatCellDate(info.getValue()),
    }),
  ];

  return (
    <PagedTable
      columns={columns}
      url="/lead/deleted"
      queryLabel={t("Search customer, VRM, CCID or deleter")}
      showTotal={true}
    />
  );
}
